import { QueryClient } from "@tanstack/react-query";
import { UserType } from "shared/types/enum";

// The Klien list (getAllCustomerByBusinessId, key ["customer", userParams],
// five-minute staleTime) carries a "Paket Tersisa" count: the client's
// packages that still have credits and have not expired. Every write that
// can change that number must refresh the list, or the count sits on the
// old value until the cache expires or the page is hard-reloaded: buying,
// upgrading, deleting or editing a package, a voucher or referral reward
// that adds credits, and a booking status change that spends or returns a
// credit. Schedule deletion and the "remove affected classes" saves refund
// bookings too, so they call it as well. The ["customer"] prefix also
// matches the V1 booking picker, the analytics and the login-code queries;
// those are cheap re-reads, and package sharing already refreshes the same
// prefix. The live pickers live under ["schedule-v2", ...] and are untouched.
export const invalidateCustomerList = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ queryKey: [UserType.Customer] });
